import classNames from 'classnames';
import React, { useCallback, useRef } from 'react';
import './ActionsBarItem.less';

export interface IActionBarClickEvent {
  item: IActionBarItemData;
  element: HTMLButtonElement | null;
}
export type IActionBarItemClick = (e: IActionBarClickEvent) => void;

export interface IActionBarItemData {
  id: string;
  label: string;
  /**
   * Used for priority resize. Item with greater priority will be hidden later if not enough room.
   */
  isGroup?: boolean;
  priority?: number;
  isPrimary: boolean;
  order: number;
}

export interface IActionBarItemProps {
  item: IActionBarItemData;
  className?: string;
  onClick: IActionBarItemClick;
}

function getRootClasses(isPrimary: boolean, isGroup?: boolean, className?: string) {
  const classes = classNames(
    'dpc-action-bar-item',
    {
      [`dpc-action-bar-item--primary`]: isPrimary,
      [`dpc-action-bar-item--secondary`]: !isPrimary,
      [`dpc-action-bar-item--group`]: isGroup,
    },
    className
  );

  return classes;
}

export function ActionBarItem({ className, item, onClick }: IActionBarItemProps) {
  const rootElement = useRef<HTMLButtonElement | null>(null);

  const onActionClick = useCallback(() => onClick({ item, element: rootElement.current }), [item, onClick]);

  return (
    <button
      ref={rootElement}
      className={getRootClasses(item.isPrimary, item.isGroup, className)}
      onClick={onActionClick}
    >
      <span className={'dpc-action-bar-item__label'}>{item.label}</span>
    </button>
  );
}
